import { render, staticRenderFns } from "./Contract.vue?vue&type=template&id=4a887655&scoped=true&"
import script from "./Contract.vue?vue&type=script&lang=js&"
export * from "./Contract.vue?vue&type=script&lang=js&"
import style0 from "./Contract.vue?vue&type=style&index=0&id=4a887655&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a887655",
  null
  
)

export default component.exports